<template>
  <div>
    <div v-if="loading">
      <div class="text-center">
        <b-spinner
          small
          variant="primary"
          type="grow"
          label="Spinning"/>
        <b-spinner
          small
          variant="primary"
          type="grow"
          label="Spinning"/>
        <b-spinner
          small
          variant="primary"
          type="grow"
          label="Spinning"/>
      </div>
    </div>
    <div v-else>
      <b-button
        v-b-toggle="'list-invisible-activities'"
        class="m-1"
        variant="info">
            <span class="when-open"><font-awesome-icon :icon="['fas', 'chevron-up']" />&nbsp;</span>
            <span class="when-closed"><font-awesome-icon :icon="['fas', 'chevron-down']" />&nbsp;</span>
            {{$t('label.list_external_activities')}}
        </b-button>
      <b-collapse id="list-invisible-activities">
        <div v-if="activities != null && activities.length === 0">
          <b-row class="align-center">
            <b-col><i>{{ $t('label.no_activity') }}</i></b-col>
          </b-row>
        </div>
        <div>
          <b-row class="align-center mb-md-2">
            <b-col>
              <b-button
              v-b-modal.modal-import-activities-list
              variant="primary">{{ $t('btn.import') }}</b-button>
              <b-button
              v-if="hasAdminConnector"
              v-b-modal.modal-import-activities-list-from-lds
              variant="primary">{{ $t('btn.import_lds') }}</b-button>
            </b-col>
            <b-modal
              id="modal-import-activities-list"
              title="Importer une liste d'activités"
              scrollable
              hide-footer>
              <form-import-list
                :id="id"
                :button-disabled="isDisabledButtonImportActivity"
                @sendForm="receiveForm"/>
            </b-modal>
             <b-modal
              id="modal-import-activities-list-from-lds"
              title="Importer une liste d'activités (LDS)"
              scrollable
              hide-footer>
              {{ $t('label.import_lds.explain_import') }}

              <b-alert show variant="warning" v-show="haveExternalIds">
                {{ $t('label.import_lds.warning_import') }}
              </b-alert>
              <div class="text-center">
                <b-button variant="success" @click="importFromLDS" :disabled="loading">{{ $t('btn.import') }}</b-button>
                <b-button @click="$bvModal.hide('modal-import-activities-list-from-lds')">{{ $t('btn.cancel') }}</b-button>
              </div>
            </b-modal>
          </b-row>
          <b-row>
            <b-table
              :fields="fields"
              :items="activities"
              small
              responsive>
              <template #cell(color)="row">
                <div
                  :style="{background: row.item.color}"
                  class="square"/>
              </template>
              <template #cell(cae_label)="row">
                <b-badge :style="{backgroundColor: row.item.domain_color }">{{ row.item.cae_label }}</b-badge>
              </template>
              <template #cell(icon_path)="row">
                <div
                  :style="{ backgroundImage: `url(${getIconeImgNoExt(row.item.icon_path)})`,
                            backgroundColor: row.item.color }"
                  class="square-activity"/>
              </template>
              <template #cell(cae_is_enable)="row">
                <b-badge :variant="row.item.cae_is_enable ? 'success' : 'danger'" >
                  {{ row.item.cae_is_enable ? 'Actif' : 'Inactif' }}
                </b-badge>
              </template>
              <template #cell(update)="row">
                <b-col><b-button
                  v-b-modal="'modal-update-activity-'+ row.item.cae_id"
                  size="sm"
                  variant="primary"
                  disabled>{{ $t('btn.update') }}</b-button></b-col>
                <b-modal
                  :id="'modal-update-activity-'+ row.item.cae_id"
                  title="Modifier une activité"
                  scrollable
                  hide-footer>
                </b-modal>
              </template>
            </b-table>
          </b-row>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>

import FormImportList from '../forms/FormImportList.vue';
import { getIconeImgNoExt } from '../../misc/utils';
import {GetAllCustomActivities, ImportCustomActivities} from '../../services/customactivities';
import { GetConnectorData } from '../../services/establishment';
import Titan from '../../services/titan';
import Netsoins from '../../services/proxyNetsoins.js';
import { apiUrlBase } from "../../api.js";

export default {
  name: 'ListCustomActivities',
  components: {
    FormImportList,
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
    connectors: {
      type: Array,
      default: null,
    },
  },
  computed: {
    hasNetsoinsConnector() {
      return this.connectors?.some((c) => c.cnt_name === 'NETSOINS') ?? false;
    },
    hasAdminConnector() {
      return this.connectors?.some((c) => ['NETSOINS', 'TITAN'].includes(c.cnt_name)) ?? false;
    },
    haveExternalIds() {
      return this.activities.some(a => a.external_id);
    },
    mapConnectors() {
      return this.connectors.map((c) => {
        return {
          name: c.cnt_name,
          id: c.cnt_id,
          enable: c.cnt_enable,
        }
      });
    },
  },
  data() {
    return {
      title: 'List Custom Activities',
      isDisabledButtonImportActivity: false,
      fields: [
        {
          color: {
            label: 'Couleur',
            tdClass: 'align-middle',
          },
        },
        {
          cae_label: {
            label: 'Nom',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          cae_is_enable: {
            label: 'Actif',
            tdClass: 'align-middle',
            sortable: true,
          },
        },
        {
          cae_description: {
            label: 'Description',
            tdClass: 'align-middle',
          },
        },
        {
          dac_label: {
            label: 'Domaine',
            sortable: true,
            tdClass: 'align-middle',
          },
        },
        {
          icon_path: {
            label: 'Icône',
            tdClass: 'align-middle',
          },
        },
        {
          external_id: {
            label: 'ID externe',
            tdClass: 'align-middle',
            formatter: (value) => value ?? '-'
          }
        },
        {
          update: {
            label: 'Modifier',
            sortable: false,
            tdClass: 'align-middle',
          },
        },
      ],
      loading: true,
      activities: null
    };
  },
  async mounted() {
    this.activities = await GetAllCustomActivities(this.id);
    this.loading = false;
  },
  methods: {
    async importFromLDS() {
      this.loading = true;

      try {
        const config = await GetConnectorData(this.id, this.mapConnectors);
        if (config) {
          const instance = this.hasNetsoinsConnector
            ? new Netsoins(config.apikey, config.apiurl, config.service.source)
            : new Titan(config.apilogin, config.apipassword, config.apikey, config.apiurl, config.ext_uri);

          await instance.importCustomActivitiesFromLDS(this.id, apiUrlBase.includes("store.anisen.fr"));
        }
      } catch (e) {
        this.showToast("danger", this.$t("msg.text_error_import_acts_lds"),  this.$t('msg.title.etablissement'), 3000);
      }

      this.loading = false;
    },
    async receiveForm(formList) {
      this.$root.$emit('bv::hide::modal', 'modal-import-activities-list');
      const data = await ImportCustomActivities(this.id, formList);
      if (data.error) this.makeToast('danger', data.error);
      else this.activities = data.data;
      this.loading = false;
    },
    async receiveUpdate(formActivity) {
      this.$root.$emit('bv::hide::modal', `modal-update-activities-${formActivity.cae_id}`);
      this.activities = await GetAllCustomActivities(this.id);
    },
    makeToast(type, message) {
      this.$bvToast.toast(message, {
        noCloseButton: true,
        variant: type,
        autoHideDelay: 5000,
      });
      this.buttonDisabled = false;
    },
    getIconeImgNoExt,
  },
};
</script>
<style>
.square-activity {
  width: 35px;
  height: 35px;
  border-radius: 5px;
  background-size: contain;
  background-repeat: no-repeat;
  padding: 5px;
  background-origin: content-box;
  background-position: center;
}
tbody {
  font-size: 0.79em;
}
.table thead th {
  font-size: 0.8em
}
</style>
